import { render, staticRenderFns } from "./ProgramPackHead.vue?vue&type=template&id=47fb81ec&scoped=true&"
import script from "./ProgramPackHead.vue?vue&type=script&lang=ts&"
export * from "./ProgramPackHead.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramPackHead.vue?vue&type=style&index=0&id=47fb81ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb81ec",
  null
  
)

export default component.exports